// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"eV","plusIcon":"eW","circle":"eX","title":"eY","disabledColor":"eZ"};